import { COMMON_EVENT_NAMES } from "../../constants";

export const EVENT_NAME = {
  OPEN: "Tracks Opened",
  CLOSE: "Tracks Closed",
  RACE_NAVIGATION: COMMON_EVENT_NAMES.NAVIGATED
};
